import { render, staticRenderFns } from "./BedTimeline30Days.vue?vue&type=template&id=1604b2cc&scoped=true"
import script from "./BedTimeline30Days.vue?vue&type=script&lang=js"
export * from "./BedTimeline30Days.vue?vue&type=script&lang=js"
import style0 from "./BedTimeline30Days.vue?vue&type=style&index=0&id=1604b2cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1604b2cc",
  null
  
)

export default component.exports